// src/pages/Home.js
import React from "react";
import "../styles/css/style.css";
import "../styles/css/bootstrap.min.css";
import Header from "../components/Header";
import Carousel from "../components/Carousel";
import Aboutussection from "../components/Aboutussection";
import Services from "../components/Services";
import Partners from "../components/Partners";
import SocialResponsibility from "../components/SocialResponsibility";
import Features from "../components/Features";
import Testimonial from "../components/Testimonial";
import Footer from "../components/Footer";

const Home = () => {

  return (
    <>
      <Header/>
      <Carousel/>
      <Aboutussection/>
      <Services/>
      <Partners/>
      <SocialResponsibility/>
      <Features />
      <Testimonial/>
      <Footer />

    </>
  );
};

export default Home;
